import { createSelector } from 'reselect'

export const getInfo = createSelector(
  state => state && state.user && state.user.detail && state.user.detail.info ? state.user.detail.info : null,
  info => info
)
